import kurdish from "../../../shared/assets/flag.png";
import iraq from "../../../shared/assets/iraq.png";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import i18nModule from "../../../i18";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";

const LANGUAGES = [
  { value: "ku", label: "کوردی", flag: kurdish },
  { value: "ar", label: "العربية", flag: iraq },
  { value: "en", label: "English", flag: null },
];

const Language = ({ size = "small" }) => {
  const [language, setLanguage] = useState("en");
  const { i18n: i18nInstance } = useTranslation();

  const onChangeLang = (lang) => {
    setLanguage(lang);
    i18nModule.changeLanguage(lang);
    i18nInstance.changeLanguage(lang);
    Cookies.set("language", lang);
    localStorage.setItem("selectedLanguage", lang);
    localStorage.setItem("i18nextLng", lang);
  };

  useEffect(() => {
    const saved = Cookies.get("language") || localStorage.getItem("selectedLanguage") || "en";
    setLanguage(saved);
    i18nModule.changeLanguage(saved);
  }, []);

  return (
    <Select
      value={language}
      onChange={onChangeLang}
      size={size}
      style={{ width: "100%", minWidth: 96 }}
      optionLabelProp="label"
      popupMatchSelectWidth={false}
      placement="bottomRight"
      getPopupContainer={() => document.body}
      dropdownStyle={{ zIndex: 1200, minWidth: 140 }}
      listHeight={200}
    >
      {LANGUAGES.map((lang) => (
        <Select.Option
          key={lang.value}
          value={lang.value}
          label={
            <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
              {lang.flag ? (
                <img src={lang.flag} alt="" width={16} height={16} style={{ borderRadius: 2 }} />
              ) : (
                <span style={{ fontSize: 13 }}>EN</span>
              )}
              {lang.label}
            </span>
          }
        >
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {lang.flag ? (
              <img src={lang.flag} alt="" width={18} height={18} style={{ borderRadius: 2 }} />
            ) : (
              <span style={{ fontSize: 14 }}>EN</span>
            )}
            {lang.label}
          </span>
        </Select.Option>
      ))}
    </Select>
  );
};

export default Language;
